module.exports = __webpack_public_path__ + "img/ch20.31c6d73c.png";